<template>
      <div class="block10">
          <!-- 返回 -->
          <div class="return">
              <router-link to="/"><span class="arrow"></span>返回首页</router-link>
          </div>
          <!-- 返回 -->
          <!-- 内容 -->
          <div class="container">
            <h2 class="title1">指示灯</h2>

            <div class="container-content">
              <p>如果某个指示灯在应该亮起时没有亮起，请联系您的经销商检查故障</p>
              <img src="./img/zhishideng.png" alt="" width="100%">
              <p>
                <strong>1.空档指示灯：</strong><br>
                变档杆停在空档位置时亮起。
              </p>

              <p>
                <strong>2.照明指示灯</strong><br>
                当前照灯开关在（<img src="../img/wzd.png">）或（<img src="../img/qzd.png" >）位置时就会亮起。
              </p>
              
              <p>
                <strong>3.ABS(防抱死制动系统)指示灯</strong><br>
                打开点火开关时点亮，当时速达到大约10千米/小时时熄灭。<br>
                <router-link to="/block4/abs/">如果驾骑时点亮</router-link>
              </p>
               <p>
                <strong>4.电喷故障指示灯</strong><br>
                打开点火锁且发动机熄火开关处于<img src="../img/yunzhuan.png">（运转）位置时，短时点亮。<br>
                 <router-link to="/block31">如果发动机运转时点亮。</router-link>
              </p>
             
             
            </div>
            <div class="foot-btn">
              <div class="prev">
                <router-link to="/block9">上一页</router-link>
              </div>
              <div class="next">
                <router-link to="/block11">下一页</router-link>
              </div>
          </div>
          </div>
     
      </div>
</template>
<script>
export default {
  props: ["id"],
  watch: {'$route'(to, from) {if(this.id != null) {setlink(this.id);}}},
  mounted() {
    setlink(this);

  },
  methods: {
    goto(path) {this.$router.push({ path: path });}
  }
};
</script>